import { useMutation, useQueryClient } from "@tanstack/react-query";

import { HouseholdMemberRelationshipUpdateType } from "@/domain/householdMemberRelationship";

import { HouseholdMemberRelationshipsApi } from "../api/householdMemberRelationshipsApi";
import { HouseholdMemberRelationshipsQueryKeys } from "../queries/householdMemberRelationshipsQueries";

export const useUpdateHouseholdMemberRelationshipMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      id,
      relationshipData,
    }: {
      id: string;
      relationshipData: HouseholdMemberRelationshipUpdateType;
    }) =>
      HouseholdMemberRelationshipsApi.updateHouseholdMemberRelationship(
        id,
        relationshipData,
      ),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: HouseholdMemberRelationshipsQueryKeys.all,
      });
    },
  });
};
